































import {Component, Vue} from 'vue-property-decorator';
import signalDiagramModule from '@/store/modules/signalDiagramModule';
import Card from '@c/Card.vue';
import {uuidv4} from '@/utils/uuidUtils';
import {PModuleEvent} from '@/views/system/modules/interfaces';
import measurementsModule from '@/store/modules/entities/measurementsModule';
import SignalDiagramBox from '@c/diagrams/SignalDiagramBox.vue';
import {getSignalDiagramTitle} from '@c/diagrams/utils';
import {SignalDiagramData, TrendOptions} from '@c/diagrams/interfaces';
import {MeasurementType} from '@/views/system/measurements/enums';
import {pmoduleStoresByTypeMap} from '@/views/system/modules/configurate';
import {PModuleType} from '@/enums/configs';
import {PModuleStoreModule} from '@/store/modules/entities/pmodules/interfaces';
import Loading from '@c/controls/Loading.vue';
import PModuleButtons from '@/views/system/nodes/PModuleButtons.vue';
import trendTaskStoreModule from '@/store/modules/trendtaskModule';
import {TrendModule} from '@/views/system/trends/interfaces';
import {getModulesByGuids} from '@/store/modules/entities/pmodules/pmoduleWithMeasurementsModule';

@Component({
  components: {
    SignalDiagramBox,
    Card,
    Loading,
    PModuleButtons,
  },
})
export default class TrendTaskView extends Vue {
  // Программный модуль
  pmodule: TrendModule | null = null;

  // Показатели загрузки данных и ошибки
  loading = true;
  error = false;

  // Диаграммы сигналов
  signalDiagrams: SignalDiagramData[] = [];

  trend = new TrendOptions();

  err_text = '';

  // События ПМ
  events: PModuleEvent[] = [];

  // Получить хранилище
  get apiStore(): PModuleStoreModule {
    return (pmoduleStoresByTypeMap.get(
      this.pmodule?.module_type as PModuleType,
    ) as any) as PModuleStoreModule;
  }

  // Получить измерение по id
  getMeasurementById(id: number) {
    const data = measurementsModule.all.filter(x => x.id === id);
    if (data.length) return data[0];
    return null;
  }

  // TODO: Вынести этот код в mixin
  async created() {
    try {
      await measurementsModule.fetchAll();
      const {data} = await trendTaskStoreModule.getById(this.$route.params.id);
      this.pmodule = data;
      if (!this.pmodule || !this.pmodule.measurements) return;

      const record = await trendTaskStoreModule.getLastEvents({
        id: this.pmodule.id as number,
        eventType: 'trend_changed',
        limit: 1,
      });
      const headers: {[key: string]: number} = {};
      record[1].forEach((val: any, index: number) => {
        headers[val[0]] = index;
      });
      if (record[0].length > 0) {
        this.trend.startTs = record[0][0][headers['timestamp']];
        this.trend.data = JSON.parse(record[0][0][headers['source_data']]);
        this.trend.factors = [
          record[0][0][headers['factor_a']],
          record[0][0][headers['factor_b']],
          record[0][0][headers['factor_c']],
          record[0][0][headers['factor_d']],
        ];
        this.trend.enabled = true;
        this.err_text = '';
      } else {
        this.err_text = 'В этой задаче ещё нет событий с параметрами тренда...';
      }
      const relmod = await getModulesByGuids([this.pmodule.module_guid]);

      if (relmod.length > 0)
        relmod[0].measurements.forEach(x => {
          if (!x.measurementId) return;
          const measurement = this.getMeasurementById(x.measurementId);
          if (!measurement) return;
          if (measurement.alias != this.pmodule?.field_name) return;

          if (measurement.type === MeasurementType.Signal) {
            const moduleId = relmod[0].id as number;
            const moduleGUID = relmod[0].guid as string;
            const moduleType = relmod[0].type as PModuleType;
            this.signalDiagrams.push({
              id: uuidv4(),
              moduleId: moduleId,
              moduleGUID: moduleGUID,
              moduleType: moduleType,
              name: getSignalDiagramTitle(measurement),
              measurement: measurement,
              topBoundary: x.topWarningBoundary,
              bottomBoundary: x.bottomWarningBoundary,
              visible: true,
            });
          }
        });

      if (this.signalDiagrams) signalDiagramModule.setCanSync({diagrams: [...this.signalDiagrams]});

      this.events = await trendTaskStoreModule.getEventTypes();
    } catch (errorData) {
      if (Vue.config.devtools) {
        // печатаем ошибку в режиме разработки
        console.error(errorData);
      }
      this.error = true;
    } finally {
      this.loading = false;
    }
  }

  beforeDestroy() {
    signalDiagramModule.clear();
  }
}
